import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { fromJS } from "immutable";

import "./Dropdown.css";

/**
 * Components representing a dorpdown list of options.
 * Controlled component (no internal state)
 * @param {Array<object>} options { id, label }
 * @param {function} onChange ( selectedOptionID )
 * @param {string} selectedOptionID must be a non-empty string or `null`
 * @param {string} [placeholder]
 */
export default class Dropdown extends React.Component {
  
  static propTypes = {
    options: ImmutablePropTypes.listOf(ImmutablePropTypes.contains({
      id: PropTypes.any.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    selectedOptionID: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    cssModifier: PropTypes.string
  }
  
  static defaultProps = {
    disabled: false,
    readOnly: false
  }
  
  onChange = (event) => {
    const { disabled, readOnly } = this.props;
    if (!disabled && !readOnly) {
      // reverse the substitution of `null` we did in `render`
      const { value } = event.target;
      const isPlaceholder = value === "";
      const id = isPlaceholder ? null : value;
      this.props.onChange(id);
    }
  }
  
  render() {
    
    let { options } = this.props;
    const { selectedOptionID, placeholder, disabled, readOnly, cssModifier } = this.props;
    
    // internally we can't use `null` as a value, so we have to substitute it
    const isNullSelected = selectedOptionID === null;
    const selectedOptionValue = isNullSelected ? "" : selectedOptionID;
    
    // If a placeholder was supplied, add an option to the list
    if (placeholder) {
      options = options.unshift(fromJS({ id: "", name: placeholder }));
    }
    
    const classNames = [ "dropdown" ];
    if (cssModifier) {
      classNames.push(`dropdown--${cssModifier}`);
    }
    if (disabled) {
      classNames.push("dropdown--disabled");
    }
    if (readOnly) {
      classNames.push("dropdown--read-only");
    }
    
    return (
      <select className={classNames.join(" ")} value={selectedOptionValue} onChange={this.onChange} disabled={disabled}>
        {
          options.map(option => (
            <option key={option.get("id")} value={option.get("id")}>{option.get("name")}</option>
          ))
        }
      </select>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Dropdown.js